<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <el-header style="margin-bottom: 2px; height:56px">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
        <!-- <tags-view v-if="needTagsView" /> -->
      </div>
    </el-header>
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <!-- <breadcrumb class="breadcrumb-container" /> -->
      <!-- <check-module /> -->
      <app-main />
    </div>
    <ReviewResultModal ref="reviewResultModal" />
    <modify-login-pwd-modal ref="loginPwdModalRef" />
    <pending-popup v-if="!$store.getters.isMX" ref="PendingPopup" />
    <verify-now-popup v-if="!$store.getters.isMX" ref="VerifyNowPopup" />
  </div>
</template>

<script>
import AppMain from './components/paycools/AppMain'
import Sidebar from './components/paycools/Sidebar'
import Navbar from './components/paycools/Navbar'
import ResizeMixin from './mixin/ResizeHandler'
import ReviewResultModal from './components/Modal/ReviewResultModal'
import ModifyLoginPwdModal from '@/views/paycools/system/components/ModifyPwdModal.vue'
import PendingPopup from '@/components/PendingPopup'
// import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'Layout',
  components: {
    ModifyLoginPwdModal,
    ReviewResultModal,
    Navbar,
    // Breadcrumb,
    Sidebar,
    AppMain,
    PendingPopup,
    // PendingPopup: () => import('@/components/PendingPopup.vue'),
    VerifyNowPopup: () => import('@/components/VerifyNowPopup.vue')
  },
  mixins: [ResizeMixin],
  // 声明遍历
  data() {
    return {}
  },
  computed: {
    kycStatusCode() {
      const merchantInfo = this.$store.getters.userInfo && this.$store.getters.userInfo.merchant_info
      return merchantInfo && merchantInfo.kyc_status ? merchantInfo.kyc_status : null
    },
    needTagsView() {
      return this.$store.state.settings.tagsView
    },
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  watch: {
    '$store.getters.kycStatus': {
      handler(newStatus) {
        // 墨西哥用户不显示 KYC 弹窗
        if (this.$store.getters.isMX) return
        // 使用全局变量确保只在首次进入时弹一次，刷新页面会重置
        if (!window._pendingPopupShown && (newStatus === 1 || newStatus === 4)) {
          window._pendingPopupShown = true
          this.openPendingPopup()
        }
      },
      immediate: true
    },
    kycStatusCode: {
      handler(newStatus) {
        // 墨西哥用户不显示 KYC 弹窗
        if (this.$store.getters.isMX) return
        // 使用全局变量确保只在首次进入时弹一次，刷新页面会重置
        if (!window._pendingPopupShown && (newStatus === 1 || newStatus === 4)) {
          window._pendingPopupShown = true
          this.openPendingPopup()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$store.dispatch('user/getUnreadNotificationCount')
    const { reset_type, account_type, naire_status } = this.$store.state.user.userInfo

    // 没有重置密码跳到重置密码页面
    if (reset_type === 2 && account_type === 1) {
      this.$router.push('/systemManage/settings')
    } else if (naire_status === 2 && account_type === 1) {
      this.tipAndOpenQuestionnaireModal()
      // this.$router.push('/questionnaire')
    }
    window.addEventListener('storage', function(event) {
      if (event.key === 'unlock_merchant_admin_token') {
        // token被修改，强制刷新或退出
        window.location.reload()
      }
    })
    // 只在第一次进入系统时执行一次（使用全局变量确保跨路由唯一）
    if (!window._layoutInitialized) {
      window._layoutInitialized = true

      // 确保用户信息已加载后再检查弹窗
      const checkPendingPopup = () => {
        // 墨西哥用户不显示 KYC 弹窗
        if (this.$store.getters.isMX) return
        if (!window._pendingPopupShown) {
          // 从 store 获取 kycStatus (getInfo 时已获取)
          const kycStatus = this.$store.getters.kycStatus
          if (kycStatus === 1 || kycStatus === 4) {
            window._pendingPopupShown = true
            this.openPendingPopup()
          }
        }
      }

      // 等待 getInfo 返回后再检查
      this.$store.dispatch('user/getInfo').then(() => {
        this.$nextTick(() => {
          checkPendingPopup()
        })
      })

      // 加载商户列表
      this.$store.dispatch('user/getMerchantList')
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const toRouterName = to.name
      const allowRouters = ['Dashboard', 'System_User_Setting']
      if (allowRouters.indexOf(toRouterName) !== -1) {
        return vm
      }
      //
      const authorities = vm.$store.state.user.authorities
      const toAccessAuths = to.meta.auth ?? []

      let flag = false
      toAccessAuths.forEach(item => {
        if (authorities.indexOf(item) !== -1) {
          flag = true
        }
      })

      if (!flag) {
        // vm.$router.replace('/404')
      }

      return vm
    })
  },
  beforeRouteUpdate(to, from, next) {
    const toRouterName = to.name
    const allowRouters = ['Dashboard', 'System_User_Setting']
    if (allowRouters.indexOf(toRouterName) !== -1) {
      next()
    }

    const authorities = this.$store.state.user.authorities
    const toAccessAuths = to.meta.auth ?? []
    let flag = false
    toAccessAuths.forEach(item => {
      if (authorities.indexOf(item) !== -1) {
        flag = true
      }
    })

    if (!flag) {
      // next('/404')
    }
    next()
  },
  methods: {
    openPendingPopup() {
      // 等待组件渲染
      this.$nextTick(() => {
        if (this.$refs.PendingPopup && typeof this.$refs.PendingPopup.openDialog === 'function') {
          // Only show popup for unverified (1) or rejected (4) status
          if (this.kycStatusCode === 1 || this.kycStatusCode === 4) {
            this.$refs.PendingPopup.openDialog()
          }
        } else {
          // fallback: try shortly after in case async component hasn't resolved
          setTimeout(() => {
            if (this.$refs.PendingPopup && typeof this.$refs.PendingPopup.openDialog === 'function') {
              // Only show popup for unverified (1) or rejected (4) status
              if (this.kycStatusCode === 1 || this.kycStatusCode === 4) {
                this.$refs.PendingPopup.openDialog()
              }
            }
          }, 1000)
        }
      })
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    tipAndOpenQuestionnaireModal() {
      this.$alert('You must finish the Compliance Questionnaire before you activate the account', 'Tips', {
        confirmButtonText: 'Confirm',
        // cancelButtonText: 'Casssncel',
        type: 'warning'
      }).then(() => {
        this.$router.push('/questionnaire')
      }).catch(() => {
        this.tipAndOpenQuestionnaireModal()
      })
    }
  }

}
</script>

<style lang="scss" scoped>
  @import "~@/styles/paycools/mixin.scss";
  @import "~@/styles/paycools/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    // height: 100%;
    // width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }

  .breadcrumb-container {
    margin: 20px 0 -3px 20px;
  }
  .sidebar-container {
    -webkit-box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
    box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
  }
</style>
